import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container">
      <h1>About InazumaDle</h1>
      <p>Hi! I'm Mario, a passionate spanish fan of Inazuma Eleven who created this game for fun.</p>
      <p><span className="gold-text">InazumaDle</span> is a daily guessing game where you try to identify a random Inazuma Eleven character based on hints. There are over 1000 players from Inazuma Eleven 1, Inazuma Eleven 2, Inazuma Eleven 3, Inazuma Eleven GO and Inazuma Eleven GO Chrono Stones.</p>
      <p>This is an unofficial project not affiliated with Level-5.</p>
      <p>If you have any suggests or find any bugs you can contact me at <span className="gold-text">inazumadlegame@gmail.com</span></p>
      <p>Also, you can support the game by <a href="https://ko-fi.com/inazumadle" target="_blank" rel="noopener noreferrer" className="support-link">buying a coffee</a>. That helps me a lot.</p>
      <p>The "Dub" icon was created by <a href="https://www.flaticon.com/free-icons/world" className="support-link" title="world icons">Freepik - Flaticon</a></p>
      <p>You can go back to the game clicking <Link to="/" className="support-link">here</Link>.</p>
      <img 
        src="/images/shawn.png" 
        alt="Shawn" 
        className="aboutprivacyimage"
      />
    </div>
  );
}
